import React from 'react';
import LandPageTypes from '../LandPageTypes';
import AdminPageTypes from '../AdminPageTypes';
import Datatable from '../controls/Datatable.jsx';
import SelectEvent from '../controls/SelectEvent.jsx';
import DatatablesCallbacks from '../../datatables/DatatablesCallbacks';
import '../../../resources/css/relatorio.css';
import {setDatetimePicker} from "../controls/DatetimePicker";

class VendasTotais extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const app = this.props.app;

        if (app.landPage !== LandPageTypes.ADMIN || app.adminPage !== AdminPageTypes.RELATORIO_VENDAS_TOTAIS)
            return null;

        const token = this.props.token;
        const eventId = this.props.participants.selectedEvent ? this.props.participants.selectedEvent.id : null;

        const datatablesColumns = [
            { data: "category.name", title: "Categoria", render: $.datatable.renders.text() },
            { data: "total", title: "Total (R$)", render: $.datatable.renders.money(".", ",", 2) },
            { data: "percent", title: "Percentual (%)", render: $.datatable.renders.number(".", ",", 2) },
        ];

        let urlBase = '/api/reports/vendas/total';

        let callbacks = new DatatablesCallbacks({
            token: token,
            selectUrl: `${urlBase}?${$.param(_.pickBy({eventId}, _.identity))}`,
        });

        const buttons = [
            {
                extend: 'csv',
                text: 'download',
                fieldSeparator: ';',
                filename: 'VendasTotais',
            },
            {
                text: 'Início: não especificado',
                className: 'inicio-datetime-picker',
            },
            {
                text: 'Fim: não especificado',
                className: 'fim-datetime-picker',
            },
        ];

        const postCreation = function (dt) {
            function updateUrl() {

                const query = {
                    inicio: inicioDate,
                    fim: fimDate,
                    eventId,
                };

                callbacks._selectUrl = `${urlBase}?${$.param(_.pickBy(query, _.identity))}`;
                dt.ajax.reload();
            }

            let inicio = ".report-vendas-totais-datatables .inicio-datetime-picker";
            let inicioDate = null;
            let fim = ".report-vendas-totais-datatables .fim-datetime-picker";
            let fimDate = null;

            setDatetimePicker(inicio, (ev) => {
                $(inicio).text('Início: ' + ev.text);
                inicioDate = ev.query;
                updateUrl();
            });

            setDatetimePicker(fim, (ev) => {
                $(fim).text('Fim: ' + ev.text);
                fimDate = ev.query;
                updateUrl();
            });
        };

        const domClassName = 'report-vendas-totais-datatables';

        return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <h2>Relatório de Vendas Totais</h2>
                    </div>
                </div>

                <SelectEvent {...this.props}/>

                <Datatable DomClassName={domClassName}
                           title={null}
                           subTitle={null}
                           responsive={true}
                           pageLength={100}
                           buttons={buttons}
                           editorCreateVisible={false}
                           editorEditVisible={false}
                           editorRemoveVisible={false}
                           datatablesSelect={callbacks.select.bind(callbacks)}
                           datatablesColumns={datatablesColumns}
                           postCreation={postCreation}
                />
            </div>
        );
    }
}

export default VendasTotais;



// WEBPACK FOOTER //
// src/views/pages/RelatorioVendasTotais.jsx